import MultiDecimalHelper from "@/utils/multi-decimal"
import SubItemsModel from "@/utils/items-model"
import cloneDeep from 'lodash-es/cloneDeep';
import {
  ItemType,
  LineItemEntityType,
  PLAN_LINE_ENTITY_TYPES,
  ADDON_LINE_ENTITY_TYPES,
} from "@/utils/item-type-constants"

export default class Helper {
    static constructOneTimeOrderItemsFromCart(response) {
      var orderItem = {};
      //addons
      orderItem.addons = Object.assign([], response.addons);
      orderItem.addons.forEach(addon => {
        addon.initialQuantity = addon.quantity;
        addon.type = ItemType.ADDON;
      });

      //charges
      orderItem.charges = Object.assign([], response.charges);

      //coupons
      orderItem.coupon_list = Object.assign([], response.coupons);
      orderItem.coupon_list.forEach(coupon => coupon.type = ItemType.COUPON);

      /* manual discounts append to coupon_list array */
      orderItem.coupon_list = orderItem.coupon_list.concat(this.getManualDiscounts(response));

      orderItem.coupon_list = this.segregateAndSort(orderItem.coupon_list);

      return orderItem;
    }
    static constructOrderItemsFromCart({order, subscription_estimate, immediate_invoice_estimate}, oldItem) {
      var orderItem = {};
      const oldPlan = oldItem?.plan;
      //plan
      orderItem.plan = Object.assign({}, order?.plan);
      orderItem.plan.type = ItemType.PLAN;
      orderItem.plan.initialQuantity = oldPlan?.initialQuantity
        ? oldPlan.initialQuantity
        : MultiDecimalHelper.getInitialQuantity(order?.plan);
      orderItem.plan.quantity_meta_overrides = oldPlan?.quantity_meta_overrides;
      orderItem.zero_dollar_plan = oldItem?.zero_dollar_plan;
      /**
       * populating curreny code from subscription_estimate
       * TODO: to check why currency_code is not returned in order plan details
       */
      if (orderItem.plan.details && !orderItem.plan.details.currency_code && subscription_estimate) {
        orderItem.plan.details.currency_code = subscription_estimate.currency_code
      }

      //addons
      orderItem.addons = Object.assign([], order?.addons || []);
      orderItem.addons.forEach(addon => {
          if(oldItem) {
              let oldAddon = (oldItem.addons || []).filter(a => a.id == addon.id)[0];
              addon.initialQuantity = oldAddon ? (oldAddon.initialQuantity || MultiDecimalHelper.getQuantity(oldAddon)) : MultiDecimalHelper.getInitialQuantity(addon);
              addon.quantity_meta_overrides = oldAddon?.quantity_meta_overrides
          } else {
              addon.initialQuantity = MultiDecimalHelper.getInitialQuantity(addon);
          }
          addon.type = ItemType.ADDON;
      });
      //event based addons/charges
      orderItem.event_based_addons = Object.assign([], order?.event_based_addons || []);
      var immediateLineItemIds = immediate_invoice_estimate?.line_items
        ?.map(lineItemId => lineItemId.entity_id);
      if(immediateLineItemIds) {
        orderItem.event_based_addons.forEach(event_based_addon => {
          event_based_addon.isImmediatelyCharged = immediateLineItemIds.includes(event_based_addon.id)
        })
      }
     
      //coupons
      orderItem.coupon_list = Object.assign([], order?.coupons || []);
      orderItem.coupon_list.forEach(coupon => coupon.type = ItemType.COUPON);

      //orderItem.coupon = orderItem.coupon_list[0] && orderItem.coupon_list[0].id;

      if(oldItem?.replace_coupon_list) {
        orderItem.replace_coupon_list = true;
      }

      if(oldItem?.replace_addon_list) {
        orderItem.replace_addon_list = true;
      }

      /* fetch manual discounts & append in coupon_list array */
      orderItem.coupon_list = orderItem.coupon_list.concat(this.getManualDiscounts(order));

      orderItem.coupon_list = this.segregateAndSort(orderItem.coupon_list);

      if (oldItem && oldItem.additionalPlans && oldItem.additionalPlans.length) {
        const estimateAdditionalPlansById = {};
        (order?.additionalPlans || []).forEach((plan) => {
          estimateAdditionalPlansById[plan.id] = plan;
        });
        orderItem.additionalPlans = oldItem.additionalPlans.map((oldPlan) => {
          const estimatePlan = estimateAdditionalPlansById[oldPlan.id];
          const mergedPlan = Object.assign({}, oldPlan, estimatePlan || {});
          mergedPlan.type = ItemType.PLAN;
          mergedPlan.initialQuantity = oldPlan.initialQuantity != null
            ? oldPlan.initialQuantity
            : MultiDecimalHelper.getInitialQuantity(mergedPlan);
          mergedPlan.quantity_meta_overrides = oldPlan.quantity_meta_overrides;
          if (mergedPlan.details && !mergedPlan.details.currency_code && subscription_estimate) {
            mergedPlan.details.currency_code = subscription_estimate.currency_code;
          }
          return mergedPlan;
        });
      }
      
      return orderItem;
  }


  static constructOrderItems(hostedPage, getters) {
    var orderItem = this.getOrderItemTemplate(hostedPage.subscription, hostedPage.subscription_items, getters);
    orderItem.zero_dollar_plan = hostedPage.is_zero_dollar_plan;
    orderItem.addons = this.getOrderItemAddons(hostedPage);
    if(hostedPage.coupon) { //TODO: Remove this once multicoupon backend released
      orderItem.coupon_list = Object.assign([], [{code: hostedPage.coupon, type: ItemType.COUPON }]);
    } else if(hostedPage.coupons) {
      orderItem.coupon_list = [];
      hostedPage.coupons.forEach(coupon_code => {
        orderItem.coupon_list.push({code: coupon_code, type: ItemType.COUPON});
      });
    }

    /* manual discounts passed via HP API params -> append to coupon_list array */
    if (hostedPage.manual_discounts) {
      if (orderItem.coupon_list == undefined)
        orderItem.coupon_list = [];
      orderItem.coupon_list = orderItem.coupon_list.concat(this.getManualDiscounts(hostedPage));
    }

    orderItem.coupon_list = this.segregateAndSort(orderItem.coupon_list);

    return orderItem;
  }

  static shouldUseMpsMultiPlan(subscription, isMpsEnabled) {
    return !!(isMpsEnabled && subscription && subscription.is_items_model);
  }

  static isPlanLine(lineItem) {
    return PLAN_LINE_ENTITY_TYPES.has(lineItem.entity_type);
  }

  static isAddonLine(lineItem) {
    return ADDON_LINE_ENTITY_TYPES.has(lineItem.entity_type);
  }

  static getPlanSubscriptionItems(subscription) {
    return (subscription.subscription_items || []).filter(item => SubItemsModel.isPlan(item));
  }

  static constructPlanFromSubscriptionItem(subItem, subscription) {
    return {
      id: subItem.item_price_id,
      quantity: subItem.quantity,
      quantity_in_decimal: subItem.quantity_in_decimal,
      type: ItemType.PLAN,
      initialQuantity: MultiDecimalHelper.getInitialQuantity(subItem),
      isZero: subItem.unit_price == 0,
      ...this.getMeteredPlanProps(subscription, [subItem]),
    };
  }

  static buildFallbackPlan(subscription) {
    return {
      id: subscription.plan_id,
      quantity: subscription.plan_quantity,
      quantity_in_decimal: MultiDecimalHelper.getQuantity(subscription),
      initialQuantity: subscription.quantity,
      type: ItemType.PLAN,
      ...this.getMeteredPlanProps(subscription)
    };
  }

  static appendMeteredAddons(orderItem, subscription) {
    const subscriptionAddons = this.getOrderItemAddons(subscription);
    const meteredAddons = subscriptionAddons.filter(addon => addon.metered);
    orderItem.addons = [...(orderItem.addons || []), ...meteredAddons];
  }

  static getAllPlans(entity) {
    if (!entity) {
      return [];
    }
    // Prefer pre-merged `plans` when present (display), else plan + additionalPlans.
    if (Array.isArray(entity.plans)) {
      return entity.plans;
    }
    if (!entity.plan) {
      return [];
    }
    return [entity.plan].concat(entity.additionalPlans || []);
  }

  static getPlanDisplayName(plan) {
    const details = plan && plan.details ? plan.details : {};
    return details.invoice_name || details.external_name || details.name || ' ';
  }

  /**
   * Plans to render on portal home/details. When hide_plan hides a non-metered
   * primary (zero-dollar / no line item), drop only that primary — additional
   * MPS plans must still show.
   */
  static getVisibleSubscriptionPlans(display) {
    const allPlans = this.getAllPlans(display);
    const primaryHidden = !!(display && display.hide_plan && !display.isMeteredPlan);
    return primaryHidden ? allPlans.slice(1) : allPlans;
  }

  static getHomeDisplayItems(display, maxVisible = 2) {
    const allPlans = this.getAllPlans(display);
    const addons = (display && display.addons) || [];
    const primaryHidden = !!(display && display.hide_plan && !display.isMeteredPlan);
    const plans = this.getVisibleSubscriptionPlans(display);

    const visiblePlans = plans.slice(0, maxVisible);
    const remainingSlots = Math.max(0, maxVisible - visiblePlans.length);
    const visibleAddons = addons.slice(0, remainingSlots);
    const hiddenCount =
      (plans.length - visiblePlans.length) + (addons.length - visibleAddons.length);

    // primaryVisible: first visible plan is the primary (not shown only because primary was hidden).
    const primaryVisible = !primaryHidden && allPlans.length > 0;

    return { visiblePlans, visibleAddons, hiddenCount, primaryVisible };
  }

  static collectPlansFromEstimate(estimate, subscription, isMps) {
    const plans = [];
    const seenPlanIds = new Set();

    ((estimate && estimate.line_items) || []).forEach((lineItem) => {
      if (this.isPlanLine(lineItem)) {
        const plan = this.constructItem(ItemType.PLAN, lineItem, estimate);
        plans.push(plan);
        seenPlanIds.add(plan.id);
      }
    });

    // MPS: rescue metered/zero-dollar plans missing from estimate line items.
    if (isMps && subscription) {
      this.getPlanSubscriptionItems(subscription).forEach((subItem) => {
        if (!seenPlanIds.has(subItem.item_price_id)) {
          plans.push(this.constructPlanFromSubscriptionItem(subItem, subscription));
          seenPlanIds.add(subItem.item_price_id);
        }
      });
    }

    // Fallback when estimate has no plan line item.
    if (!plans.length && subscription) {
      plans.push(this.buildFallbackPlan(subscription));
    }

    return plans;
  }

  static collectPlansFromSubscription(subscription, options = {}) {
    const planItems = this.getPlanSubscriptionItems(subscription).map(
      subItem => this.constructPlanFromSubscriptionItem(subItem, subscription)
    );
    if (planItems.length) {
      return planItems;
    }
    // Fall back to legacy single-plan template.
    return [this.getOrderItemTemplate(subscription, null, null, options).plan];
  }

  static collectAddonsAndSetupFromEstimate(estimate) {
    const addons = [];
    let planSetup;
    ((estimate && estimate.line_items) || []).forEach((lineItem) => {
      if (this.isAddonLine(lineItem)) {
        addons.push(this.constructItem(ItemType.ADDON, lineItem, estimate));
      } else if (lineItem.entity_type === LineItemEntityType.PLAN_SETUP) {
        planSetup = {
          type: ItemType.PLAN_SETUP,
          id: lineItem.entity_id,
          lineItem: lineItem,
        };
      }
    });
    return { addons, planSetup };
  }

  static assembleOrderItem({ plans, addons, planSetup }, isMps) {
    const orderItem = { addons: addons || [] };
    if (planSetup) {
      orderItem.plan_setup = planSetup;
    }
    if (plans && plans.length) {
      orderItem.plan = plans[0];
      if (isMps && plans.length > 1) {
        orderItem.additionalPlans = plans.slice(1);
      }
    }
    return orderItem;
  }

  static constructOrderItemsFromSubscription(subscription, options = {}) {
    const isMps = this.shouldUseMpsMultiPlan(subscription, options.isMpsEnabled);

    if (!isMps) {
      const orderItem = this.getOrderItemTemplate(subscription, null, null, options);
      orderItem.addons = this.getOrderItemAddons(subscription);
      return orderItem;
    }

    return this.assembleOrderItem({
      plans: this.collectPlansFromSubscription(subscription, options),
      addons: this.getOrderItemAddons(subscription),
    }, isMps);
  }

  static constructOrderItemsFromEstimate(estimate, subscription, options = {}) {
    const isMps = this.shouldUseMpsMultiPlan(subscription, options.isMpsEnabled);

    const plans = this.collectPlansFromEstimate(estimate, subscription, isMps);
    const { addons, planSetup } = this.collectAddonsAndSetupFromEstimate(estimate);

    const orderItem = this.assembleOrderItem({ plans, addons, planSetup }, isMps);

    // Metered addons are absent from estimate; pull from subscription.
    this.appendMeteredAddons(orderItem, subscription);
    return orderItem;
  }

  static constructItem(type, line_item, estimate) {
    const orderItem = {
      type: type,
      id: line_item.entity_id,
      lineItem: line_item,
      quantity: line_item.quantity,
      initialQuantity: line_item.quantity,
      pricing_model: line_item.pricing_model,
      unit_amount: line_item.unit_amount,
      amount: line_item.amount,
      tiers: ((estimate.line_item_tiers && estimate.line_item_tiers.filter(t => t.line_item_id == line_item.id)) || [])
    }

    if(MultiDecimalHelper.isMultiDecimal(line_item)) {
      orderItem.quantity_in_decimal = MultiDecimalHelper.getQuantity(line_item);
      orderItem.initialQuantity = MultiDecimalHelper.getInitialQuantity(line_item);
      orderItem.unit_amount_in_decimal = MultiDecimalHelper.getUnitAmount(line_item);
      orderItem.amount_in_decimal = MultiDecimalHelper.getAmount(line_item);
    }

    return orderItem;
  }

  static constructAddons(data) {
    var output = [];
    var tmpMap = {};
    this.getAddonFields(data).forEach((key) => {
      let tmp = key.match(/addons\[(.*)\]\[(.*)\]/) && key.match(/addons\[(.*)\]\[(.*)\]/).slice(1);
      if(!['id', 'quantity', 'quantity_in_decimal'].includes(tmp[0])){
        return;
      }
      if(tmp.length == 2){
        if(!tmpMap[tmp[1]]) {
          tmpMap[tmp[1]] = {};
          output.push(tmpMap[tmp[1]]);
        }
        tmpMap[tmp[1]][tmp[0]] = this._getField(data, key);
      }
    });
    return output;
  }

  static constructPlanSetup(planSetupLineItem) {
    if(!planSetupLineItem) return;
    return {
      type: ItemType.PLAN_SETUP,
      id: planSetupLineItem.entity_id,
      lineItem: planSetupLineItem,
      amount: planSetupLineItem && planSetupLineItem.amount
    }
  }

  static getAddonFields(hostedPage) {
    return Object.keys(hostedPage).filter(param => param.startsWith("addons"));
  }

  static _getField(data, field) {
    return data[field];
  }

  static getCurrentTimestamp(){
    return new Date().getTime();
  }

  static getMeteredPlanProps(subscription, subscription_items) {
    const items = subscription_items || subscription.subscription_items || []
    const meteredPlan = items.find(item => item.item_type === ItemType.PLAN && item.hasOwnProperty('metered_quantity'))
    let meteredPlanProps = {}
    if (meteredPlan) {
      meteredPlanProps = {
        metered: true,
        metered_quantity: meteredPlan.metered_quantity,
        last_calculated_at: meteredPlan.last_calculated_at,
        has_non_zero_metered_quantity: this.isNonZero(meteredPlan.metered_quantity),
        id: meteredPlan.item_price_id
      }
    }
    return meteredPlanProps
  }

  static getOrderItemTemplate(subscription, subscription_items, getters, options = {}){
    var orderItem = {};
    if (getters && getters.is_checkout_one_time) {
      return orderItem;
    }
    const { isMpsEnabled = false } = options;
    orderItem = {
      plan: {
        id: subscription.plan_id,
        quantity: subscription.plan_quantity,
        quantity_in_decimal: subscription.plan_quantity_in_decimal,
        type: ItemType.PLAN,
        initialQuantity: MultiDecimalHelper.getInitialQuantity(subscription),
        ...this.getMeteredPlanProps(subscription, subscription_items)
      }
    }

    if (!subscription_items && subscription.subscription_items && subscription.subscription_items.length > 0) {
      const sourceItem = isMpsEnabled
        ? subscription.subscription_items.find(item => item.item_type === ItemType.PLAN)
        : subscription.subscription_items[0];
      if (sourceItem) {
        orderItem.plan.isZero = sourceItem.unit_price == 0;
        orderItem.plan.id = sourceItem.item_price_id;
        orderItem.plan.quantity = sourceItem.quantity;
        orderItem.plan.quantity_in_decimal = sourceItem.quantity_in_decimal;
      }
    }
    return orderItem;
  }
  /**
   *
   * @param {object} entity - can be either hosted page or subscription
   */
  static getOrderItemAddons(entity){
    return ((entity && entity.addons) || []).map(addon => {
      const items = entity.subscription_items || []
      const meteredAddon = items.find(item =>
        item.item_type === ItemType.ADDON && item.item_price_id === addon.id && item.hasOwnProperty('metered_quantity'))
      let meteredAddonProps = {}
      if (meteredAddon) {
        meteredAddonProps = {
          metered: true,
          metered_quantity: meteredAddon.metered_quantity,
          last_calculated_at: meteredAddon.last_calculated_at,
          has_non_zero_metered_quantity: this.isNonZero(meteredAddon.metered_quantity),
        }
      }
      return {
        ...addon,
        ...meteredAddonProps,
        initialQuantity : MultiDecimalHelper.getInitialQuantity(addon),
        type : ItemType.ADDON
      }
    });
  }
  static isNonZero(value) {
    return ! /^[0]((\.0*)*)$/.test(value)
  }

  static getManualDiscounts(order) {
    let discountsList = [];
    if (order && order.manual_discounts) {
      discountsList = order.manual_discounts;
      discountsList.forEach(discount => {
        discount.type = discount.type || "manual_discount";
      });
    }

    return discountsList;
  }

  static segregateAndSort(dataList) {
    if (dataList) {
      /* keeping legacy behaviour intact */
      if(!this.isManualDiscountPresent(dataList)) return dataList;

      /* eventually, all coupons & manual discounts will have entity_type + discount_type, sort only then to optimise */
      for (let item of dataList) {
        if (!item.entity_type || !item.discount_type) {
          if (!item.details || !item.type) {
            return dataList;
          }
        }
      }

      dataList = cloneDeep(dataList);
      let coupon_flat_line_level = [];
      let discount_flat_line_level = [];
      let coupon_percentage_line_level = [];
      let discount_percentage_line_level = [];
      let coupon_flat_invoice_level = [];
      let discount_flat_invoice_level = [];
      let coupon_percentage_invoice_level = [];
      let discount_percentage_invoice_level = [];
      let no_category_data = [];
      let result = [];

      /* segregate into individual categories */
      dataList.forEach(item => {
        let item_discount_type, item_entity_type;

        /* discount type : FIXED AMOUNT vs PERCENTAGE */
        if (!!item.discount_type) item_discount_type = item.discount_type.toUpperCase();
        else if (!!item.details) item_discount_type = item.details.discount_type.toUpperCase();

        /* entity type : line_level vs invoice_level */
        if (!!item.entity_type) item_entity_type = item.entity_type.toUpperCase();
        else {
          if (!!item.type && !!item.details) {
            let item_apply_on = item.details.apply_on.toUpperCase();
            if (item.type === ItemType.COUPON) {
              if(item_apply_on === this.ApplicableType.EACH_SPECIFIED_ITEM) item_entity_type = this.EntityType.ITEM_LEVEL_COUPON;
              else if (item_apply_on === this.ApplicableType.INVOICE_AMOUNT) item_entity_type = this.EntityType.DOCUMENT_LEVEL_COUPON;
            } else if (item.type === "manual_discount") {
              if (item_apply_on === this.ApplicableType.EACH_SPECIFIED_ITEM) item_entity_type = this.EntityType.ITEM_LEVEL_DISCOUNT;
              else if (item_apply_on === this.ApplicableType.INVOICE_AMOUNT) item_entity_type = this.EntityType.DOCUMENT_LEVEL_DISCOUNT;
            }
          }
        }

        switch(item_entity_type) {
          case this.EntityType.ITEM_LEVEL_COUPON:
            if (item_discount_type === this.DiscountType.FIXED_AMOUNT) coupon_flat_line_level.push(item);
            else if (item_discount_type === this.DiscountType.PERCENTAGE) coupon_percentage_line_level.push(item);
            break;
          case this.EntityType.ITEM_LEVEL_DISCOUNT:
            if (item_discount_type === this.DiscountType.FIXED_AMOUNT) discount_flat_line_level.push(item);
            else if (item_discount_type === this.DiscountType.PERCENTAGE) discount_percentage_line_level.push(item);
            break;
          case this.EntityType.DOCUMENT_LEVEL_COUPON:
            if (item_discount_type == this.DiscountType.FIXED_AMOUNT) coupon_flat_invoice_level.push(item);
            else if (item_discount_type === this.DiscountType.PERCENTAGE) coupon_percentage_invoice_level.push(item);
            break;
          case this.EntityType.DOCUMENT_LEVEL_DISCOUNT:
            if (item_discount_type === this.DiscountType.FIXED_AMOUNT) discount_flat_invoice_level.push(item);
            else if (item_discount_type === this.DiscountType.PERCENTAGE) discount_percentage_invoice_level.push(item);
            break;
          default:
            no_category_data.push(item);
            break;
        }
      });

      let coupon_flat_consolidated_list = [];
      let coupon_percentage_consolidated_list = [];
      let discount_flat_consolidated_list = [];
      let discount_percentage_consolidated_list = [];

      /* sort within a category */
      no_category_data = this.sortByNumericalValue(no_category_data);
      coupon_flat_line_level = this.sortByNumericalValue(coupon_flat_line_level);
      coupon_flat_invoice_level = this.sortByNumericalValue(coupon_flat_invoice_level);
      coupon_percentage_line_level = this.sortByNumericalValue(coupon_percentage_line_level);
      coupon_percentage_invoice_level = this.sortByNumericalValue(coupon_percentage_invoice_level);
      discount_flat_line_level = this.sortByNumericalValue(discount_flat_line_level);
      discount_flat_invoice_level = this.sortByNumericalValue(discount_flat_invoice_level);
      discount_percentage_line_level = this.sortByNumericalValue(discount_percentage_line_level);
      discount_percentage_invoice_level = this.sortByNumericalValue(discount_percentage_invoice_level);

      coupon_flat_consolidated_list = coupon_flat_consolidated_list.concat(coupon_flat_line_level, coupon_flat_invoice_level);
      coupon_percentage_consolidated_list = coupon_percentage_consolidated_list.concat(coupon_percentage_line_level, coupon_percentage_invoice_level);
      discount_flat_consolidated_list = discount_flat_consolidated_list.concat(discount_flat_line_level, discount_flat_invoice_level);
      discount_percentage_consolidated_list = discount_percentage_consolidated_list.concat(discount_percentage_line_level, discount_percentage_invoice_level);

      /* merge sorted sub-categories */
      result = result.concat(no_category_data,
        coupon_flat_consolidated_list, coupon_percentage_consolidated_list,
        discount_flat_consolidated_list, discount_percentage_consolidated_list);

      return result;
    }

    return dataList;
  }

  static sortByNumericalValue(dataList) {
    if (!!dataList) {
      dataList.sort((item1, item2) => {
        let item1Value, item2Value;
        let item1ComputedAmount = 0, item2ComputedAmount = 0;

        if (this.isManualDiscount(item1)) {
          /* manual discount */
          let item1Amount = item1.description || item1.details.invoice_name;
          let item2Amount = item2.description || item2.details.invoice_name;
          item1Value = parseInt(item1Amount.replace(/[^0-9]/g, '')) || 0;
          item2Value = parseInt(item2Amount.replace(/[^0-9]/g, '')) || 0;

          /* computed amount in case of percentage, for flat/fixed type computed amount = amount set */
          item1ComputedAmount = item1.amount || item1.details.discount_amount || 0;
          item2ComputedAmount = item2.amount || item2.details.discount_amount || 0;
        } else {
          /* coupon */
          /* no computed amount as BE API shares only computed amount even in case of percentage type */
          item1Value = item1.amount || 0;
          item2Value = item2.amount || 0;
        }

        /* sort in decreasing order -> higher amount / percentage first */
        if (item1Value == item2Value)
          return item2ComputedAmount - item1ComputedAmount;
        return item2Value - item1Value;
      });

      return dataList;
    }

    return dataList;
  }

  static isManualDiscount(data) {
    if (data) {
      /* estimate API */
      if (!!data.entity_type) return data.entity_type.toUpperCase() === this.EntityType.ITEM_LEVEL_DISCOUNT || data.entity_type.toUpperCase() === this.EntityType.DOCUMENT_LEVEL_DISCOUNT;
      /* order -> coupon_list */
      if (!!data.type) return data.type == "manual_discount";
    }

    return false;
  }

  /* util to find if atleast one manual discount present in a list of coupons / manual_discount */
  static isManualDiscountPresent(item_list) {
    if (item_list) {
      return item_list.find(item => this.isManualDiscount(item)) != undefined;
    }

    return false;
  }

  static get EntityType() {
    return {
      ITEM_LEVEL_COUPON: "ITEM_LEVEL_COUPON",
      ITEM_LEVEL_DISCOUNT: "ITEM_LEVEL_DISCOUNT",
      DOCUMENT_LEVEL_COUPON: "DOCUMENT_LEVEL_COUPON",
      DOCUMENT_LEVEL_DISCOUNT: "DOCUMENT_LEVEL_DISCOUNT",
      PROMOTIONAL_CREDITS: "PROMOTIONAL_CREDITS",
      PRORATED_CREDITS: "PRORATED_CREDITS",
    };
  };

  static get DiscountType() {
    return {
      FIXED_AMOUNT: "FIXED_AMOUNT",
      PERCENTAGE: "PERCENTAGE"
    };
  }

  static get ApplicableType() {
    return {
      INVOICE_AMOUNT: "INVOICE_AMOUNT",
      EACH_SPECIFIED_ITEM: "EACH_SPECIFIED_ITEM"
    };
  }
  static isPayNow(hosted_page_type) {
    return hosted_page_type == "paynow";
  }
}
